import type { App } from 'vue';
import { createPinia } from 'pinia';

export const pinia = createPinia();

export default {
  install(app: App) {
    app.use(pinia);
  },
};
